
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { asideMenuIcons } from "@/core/helpers/config";
import { useStore } from "vuex";

export default defineComponent({
  name: "SubMenu",
  components: {
  },
  props: {
    menu: Array,
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      asideMenuIcons,
      translate,
      hasPermission (item) {
        let user = store.getters.currentUser
        // 广告平台只有授予广告模块的用户才可以，管理员也不例外
        if(item.name === 'ads.name' && user.permissions) return user.permissions.indexOf(user.site_id + ':ads') > -1
        if(!item.meta || user.is_superuser === true) return true
        if(!user.permissions) return false
        if (item.meta.is_superuser)
          return user.is_superuser === true
        else if (item.meta.is_staff)
          return user.is_staff === true
        else if (item.meta.permission)
          return user.permissions.indexOf(user.site_id + ':' + item.meta.permission) > -1
        else
          return true
      }
    };
  },
});
